
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/podcasts/items/[podcastsAlias]",
      function () {
        return require("private-next-pages/podcasts/items/[podcastsAlias]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/podcasts/items/[podcastsAlias]"])
      });
    }
  